export default [
  '$rootScope',
  '$scope',
  '$window',
  '$cookies',
  'AuthService',
  'UserDataService',
  class EventBroadcasterController {
    constructor($rootScope, $scope, $window, $cookies, AuthService, UserDataService) {
      this._$rootScope = $rootScope;
      this._$window = $window;
      this._$cookies = $cookies;
      this._authService = AuthService;
      this._userDataService = UserDataService;
      this.canScroll = true;

      $scope.$on('menu-toggle', (event, args) => {
        this.canScroll = args.canScroll;
      });

      $scope.$on('slide-menu-toggle', (event, args) => {
        this.canScroll = args.canScroll;
        this.isSlideMenuOpen = !this.canScroll;
      })
    }

    openLogin(route, email) {
      this._$rootScope.$broadcast('login:open', { route, email });
    }

    openRegister() {
      this._$rootScope.$broadcast('register:open', {});
    }

    gravatar() {
      if (this._$cookies.get('gravatar')) {
        return `https://www.gravatar.com/avatar/${this._$cookies.get('gravatar')}`;
      }
      return false;
    }
  }
]



// WEBPACK FOOTER //
// ./source/client/layout-components/account/event-broadcaster/event-broadcaster.ctrl.js